import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import NewsBlock from '../components/News/NewsBlock'
import { getAllNews } from '../api'
import { useLocation } from 'react-router-dom'
import { BottomNavBar } from '../components/Header';

function News() {
  const [news, setNews] = useState([])
  const location = useLocation();
  useEffect(() => {
    getAllNews().then(data => {
      setNews(data)
      if (location.pathname === '/news' && data && data.length > 0) {
        localStorage.setItem('lastSeenNewsId', data[0]._id)
      }
    })
    // eslint-disable-next-line
  }, [location.pathname])

  return (
    <div className='News'>
        <Header />
        <div className="News__container">
            {news.map(n => <NewsBlock news={n} key={n._id} />)}
        </div>
        <BottomNavBar />
    </div>
  )
}

export default News